import React from 'react';

/**
 * What the server's `actions` allow on the pay period on screen: submit, approve, return,
 * reopen. In the sidebar card on the day view; `compact` in the header bar on the week and pay
 * period views, where there is no sidebar.
 */
export default function PeriodActions({ actions, onAction, compact = false }) {
  const single = compact ? 'bdc-btn bdc-btn--sm' : 'bdc-btn ts-side-card__action';
  const pair = compact ? 'bdc-btn bdc-btn--sm' : 'bdc-btn';
  const review = (
    <>
      <button type="button" className={pair} onClick={() => onAction('return')}>
        <i className="bi bi-arrow-counterclockwise" aria-hidden="true" />
        Return
      </button>
      <button type="button" className={`${pair} bdc-btn--primary`} onClick={() => onAction('approve')}>
        <i className="bi bi-check-lg" aria-hidden="true" />
        Approve
      </button>
    </>
  );

  return (
    <>
      {actions.canSubmit ? (
        <button type="button" className={single} onClick={() => onAction('submit')}>
          <i className="bi bi-calendar-check" aria-hidden="true" />
          Submit for approval
        </button>
      ) : null}
      {actions.canReview ? (compact ? review : <div className="ts-side-card__pair">{review}</div>) : null}
      {actions.canReopen ? (
        <button type="button" className={single} onClick={() => onAction('reopen')}>
          <i className="bi bi-unlock" aria-hidden="true" />
          Reopen
        </button>
      ) : null}
    </>
  );
}
